import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/tr';
import 'moment/locale/ar';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAppState } from '../../models/action/core';
import Switch from 'react-switch';

const T = Translator.create();
const _common = new Common();

// Setting moment locale based on current language
moment.locale(T.i18next.language);

interface ComunicationModulesProps { }

interface ComunicationModulesState {
}

class CComunicationModule extends React.Component<ComunicationModulesProps, ComunicationModulesState> {


     constructor(props: ComunicationModulesProps) {
          super(props);
          this.state = {

          };
     }



     render() {

          return (<>
               <div className="row settings-line">
                    <div className="setting col-md-3 col-12 mini-line">
                         <span className='title flex-column'>
                              {T.t("r_activity_type_Forum")}
                              <span className="explain">{T.t("r_modules_forum")}</span>
                         </span>
                         <div className='specs'>
                              <label className="switch" >
                                   <Switch
                                        id={'check-autoEnroll'}
                                        name={'autoEnroll'}
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onChange={(e: any) => ''}
                                        checked={true}
                                        defaultChecked={true}
                                        onColor="#358730"
                                        onHandleColor="#358730"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={20}
                                        width={38}
                                        className="react-switch"
                                   />
                              </label>
                         </div>
                    </div>

                    <div className="setting col-md-3 col-12 mini-line">
                         <span className='title flex-column'>
                              {T.t("r_menu_announcements")}
                              <span className="explain">{T.t("r_modules_annoucement")}</span>
                         </span>
                         <div className='specs'>
                              <label className="switch" >
                                   <Switch
                                        id={'check-autoEnroll'}
                                        name={'autoEnroll'}
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onChange={(e: any) => ''}
                                        checked={true}
                                        defaultChecked={true}
                                        onColor="#358730"
                                        onHandleColor="#358730"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={20}
                                        width={38}
                                        className="react-switch"
                                   />
                              </label>
                         </div>
                    </div>

{/* uncheck yapılırsa disabled class'ı gelmelidir */}
                    <div className="setting col-md-3 col-12 mini-line disabled">
                         <span className='title flex-column'>
                              {T.t("r_menu_messages")}
                              <span className="explain">{T.t("r_modules_message")}</span>
                         </span>
                         <div className='specs'>
                              <label className="switch" >
                                   <Switch
                                        id={'check-autoEnroll'}
                                        name={'autoEnroll'}
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onChange={(e: any) => ''}
                                        checked={false}
                                        defaultChecked={true}
                                        onColor="#358730"
                                        onHandleColor="#358730"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={20}
                                        width={38}
                                        className="react-switch"
                                   />
                              </label>
                         </div>
                    </div>

               </div>
               <div className="row px-4">
                    <div className='d-flex justify-content-end w-100 mt-4'>
                         <button className="btn btn-success" type='button'>{T.t("r_save_button")}</button>
                    </div>

               </div>
          </>
          );
     }
}



const ComunicationModule = CComunicationModule;

export default ComunicationModule;
